import {FC} from 'react'
import {Row} from 'react-table'

type Props = {
  row: Row<any>
}

const JobCustomRow: FC<Props> = ({row}) => {
  const {key, ...rowProps} = row.getRowProps()
  return (
    <tr key={key} {...rowProps}>
      {row.cells.map((cell) => {
        const {key: cellKey, ...cellProps} = cell.getCellProps()
        return (
          <td
            key={cellKey}
            {...cellProps}
            className='px-4'
          >
            {cell.render('Cell')}
          </td>
        )
      })}
    </tr>
  )
}

export {JobCustomRow}